<template>
  <div>
    <vx-card title="Statistiques dossiers">
      <vs-row style="margin-top: 20px">
        <vs-col vs-w="6">
          <span>Liste des dossiers</span>
          <v-select
            v-model="folder_id"
            class="w-full"
            label="name"
            placeholder="Sélectionner un dossier"
            :reduce="(folder) => folder.id"
            :options="folders"
          ></v-select>
        </vs-col>

        <vs-col vs-w="2">
          <vs-button :disabled="folder_id ? false : true"
            color="primary"
            style="margin-top: 20px"
            type="filled"
            @click="exportStats()"
            >Exporter</vs-button
          >
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "requestStatFolder",
  components: {},
  data: () => ({
    folders: [],
    folder_id: ''
  }),
  mounted() {
    this.getFolders();
  },
  methods: {
    async getFolders() {
      this.$vs.loading();
      this.$http
        .get("/folders?paginate=2")
        .then((response) => {
          if (response.data) {
            this.folders = response.data;
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          if (!error.response) {
            window.GETCCMT.error("Network error", {});
          } else {
            if (error.response.status == 401) {
              window.GETCCMT.error("Votre session a expiré", {});
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    async exportStats() {
      this.$vs.loading();
      this.$http
        .get("/folders/requests/" + this.folder_id + "/report")
        .then((response) => {
          const link = document.createElement("a");
          link.href = response.data.file;
          link.setAttribute("download", "report_folder.xlsx");
          document.body.appendChild(link);
          link.click();
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>

<style scoped>
</style>
